import { TextBadge } from '@carvana/ds-badge';
import { TrackClick } from '@carvana/merch-components';
import { SectionId } from '~/constants/vdp/section';
import SubSections from '~/constants/vdp/subSections';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';

export default function PriceDropBadge() {
  const isMobile = useIsMobile();
  const { analyticsAttributes, analyticsId } = useSectionAnalytics();

  return (
    <TrackClick
      className="pointer-events-auto"
      element="a"
      data-adobe-id="price-drop-badge"
      data-analytics-id={analyticsId}
      data-analytics-attributes={{
        ...analyticsAttributes,
        description: 'badge',
        text: 'Price Drop'
      }}
      data-testid="new-price-badge"
      href={
        isMobile ? `#${SubSections.NewPrice}` : `#${SectionId.AboutThePrice}`
      }
    >
      <TextBadge priority="success">Price Drop</TextBadge>
    </TrackClick>
  );
}
